import { action, observable, runInAction, makeObservable } from "mobx";
import { CoreStore, handleStoreState } from "Stores/RESTStore/CoreStore";
import { API_URL } from "General/APIEndpoints";
import { projectsDataStore } from "Stores";
import { API } from "General/API";
import { documentsSearchStore } from "./DocumentsSearchStore";

class DocumentsQueryStore extends CoreStore {
  fetchQueryState: StoreState;
  data: API_SearchQuery[] = [];

  constructor() {
    super();

    makeObservable(this, {
      fetchQueryState: observable,
      data: observable,
      clear: action.bound,
      setQueryToEdit: action.bound,
      findQueryById: action.bound,
      fetchQueries: action.bound,
      fetchQueryById: action.bound,
      editQuery: action.bound,
      saveQuery: action.bound,
      executeQuery: action.bound,
      deleteQuery: action.bound,
    });
  }

  url(id?: number) {
    return id
      ? API_URL.SEARCH.getSearchQueryById(projectsDataStore.projectId, id)
      : API_URL.SEARCH.getSearchQueries(projectsDataStore.projectId);
  }

  clear() {
    this.data = [];
    this.fetchQueryState = "RAW";
  }

  @handleStoreState()
  async fetchQueries() {
    try {
      const response = await API.getData(this.url());
      runInAction(() => {
        this.data = response;
      });
    } catch (error) {
      throw error;
    }
  }

  @handleStoreState<DocumentsQueryStore>("fetchQueryState")
  async fetchQueryById(id: number): Promise<API_SearchQuery> {
    try {
      return await API.getData(this.url(id));
    } catch (error) {
      throw error;
    }
  }

  async setQueryToEdit(queryId: number) {
    try {
      const response = await this.fetchQueryById(queryId);
      documentsSearchStore.setSearchReqQuery(response);
    } catch (error) {
      throw error;
    }
  }

  @handleStoreState()
  async editQuery(postObject: API_SearchQuery, queryId: number) {
    try {
      await API.editData(API_URL.SEARCH.editSearchQuery(projectsDataStore.projectId, queryId), postObject);
      documentsSearchStore.setSearchReqQuery({});
      await this.fetchQueries();
    } catch (error) {
      throw error;
    }
  }

  @handleStoreState()
  async saveQuery(postObject: API_SearchQuery) {
    try {
      if (documentsSearchStore.radioValue === "ALL") {
        postObject.folderId = undefined;
      }
      await API.newData(API_URL.SEARCH.storeSearchQuery(projectsDataStore.projectId), postObject);
      await this.fetchQueries();
    } catch (error) {
      throw error;
    }
  }

  @handleStoreState()
  async executeQuery(queryId: number) {
    try {
      const { id: _id, name: _name, ...postObject } = await this.fetchQueryById(queryId);
      await documentsSearchStore.sendRequest(postObject);
    } catch (error) {
      throw error;
    }
  }

  @handleStoreState()
  async deleteQuery(id: number) {
    try {
      await API.deleteData(API_URL.SEARCH.deleteQuery(projectsDataStore.projectId, id));
      runInAction(() => {
        this.data = this.data.filter((item) => item.id !== id);
      });
    } catch (error) {
      throw error;
    }
  }

  findQueryById(id: number) {
    return this.data.find((query) => query.id === id);
  }
}

export const documentsQueryStore = new DocumentsQueryStore();
